import React from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { TagsList } from './components/TagsList'

const TagsPage: React.FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Tags</PageTitle>
      <div className='d-flex flex-column flex-lg-row'>
        <div className='flex-lg-row-fluid'>
          <TagsList />
        </div>
      </div>
    </>
  )
}

export { TagsPage }

